import React from "react";

const VideoAnimation = () => {
  return (
    <div>
      <h1 className="text-3xl font-bold text-center py-5">Video & Animation</h1>
    </div>
  );
};

export default VideoAnimation;
